var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#17C964",
    d: "M12 .984c5.016 0 9.281 3.141 11.016 7.5-1.735 4.407-6 7.5-11.016 7.5a11.81 11.81 0 0 1-11.016-7.5c1.735-4.359 6-7.5 11.016-7.5M12 13.5a5.02 5.02 0 0 0 5.016-5.016c0-2.765-2.25-4.968-5.016-4.968S6.984 5.719 6.984 8.484A5.02 5.02 0 0 0 12 13.5m0-8.016c1.64 0 3 1.36 3 3 0 1.688-1.36 3-3 3s-3-1.312-3-3c0-1.64 1.36-3 3-3"
  })));
};
export default SvgEye;